<template>
    <div  style="background:white;height:100% ">           
        
        <div style="display:flex; position:fixed;width:95% ">
            <div style=" padding-left:1px;margin-top:10px "> 
                <el-timeline style="width:130px;margin-top:5px;padding-left:8px">
                    <el-timeline-item
                        v-for="(item, index) in timeArr"
                        :key="index"
                        @click.native="handleTime(item,index)"
                        :icon="item.ICON"
                        :type="item.TY"
                        :color="currentIndex==index?'red':'#389'">
                       <span style="font-size:12px"> {{item.GPNM}}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div style="display:flex;flex-direction:column; border-left :2px solid #389;width:100%">
                <div style="background:#ccc;padding-left:4px;line-height:40px; margin-left:2px ;text-align:left;font-size:14px;font-weight:600;color:#389">
                    温馨提示： 登录账号为绑定手机号码，初始密码为 2022，登录系统后可以在右上角用户头像处修改密码
                </div>
                <div :style="{'overflow-y':'auto',height:tabHeight,'padding-left':'3px','width':'100%' }" >                 
                    <span v-for="(gpitem,gpind) in formArr" :key="gpind">
                    <div  :ref="gpitem.gpno">
                        <div  class="one-toolbar">
                            <span class="spanRow"> 
                                <span v-if="gpitem.gpno!=='400070'&&gpitem.gpno!=='400071'" style="font-weight:600;font-size:14px;color:#fff;">{{gpitem.gpnm}} </span> 
                                <span v-if="gpitem.gpno=='400070'" style="font-weight:600;font-size:14px;color:#fff">上传营业执照附件 * （最多3个文档，可以是PDF或图片格式）</span> 
                                <span v-if="gpitem.gpno=='400071'" style="font-weight:600;font-size:14px;color:#fff">上传资格证书附件 （最多3个文档，可以是PDF或图片格式）</span>         
                                <el-link v-if="gpitem.gpno==='20284'" :underline="false" @click="perAdd">【新增记录】</el-link>
                                <span v-if="gpitem.gpno==='304'" style="font-weight:600;font-size:14px;color:#fff">  
                                    <el-link  :underline="false" @click="perAdd" >
                                        【<i class="iconfont icon-xinzeng" style="color:#fFF;font-size:12px;margin-right:2px;margin-left:2px;">新增联系人</i>】
                                    </el-link>        
                                </span>
                            </span>
                        </div>
                        <Form :model="perRow" :label-width="120" ref="supForm"  label-position="right" inline >  
                            <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                <FormItem  :class="item.FLDNO=='BANKADDR'?'item-width2':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'&&item.FLDNO!=='ISREG'&& item.FLDNO!=='ADDUSER'&&item.FLDNO!=='ADDDTTM'&&item.FLDNO!=='PAYMTH'">                  
                                    <template slot="label"><span v-if="item.NOTNULL=='Y'" style="color:red;margin-right:5px">*</span> {{item.FLDNM}}</template> 
                                    <el-date-picker   type="date"  v-if="item.EDCSS==='date'" v-model="perRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input-number  v-else-if="item.EDCSS==='number'" v-model="perRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                    <el-checkbox :disabled="item.DISABLED=='Y'" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                    <el-select  v-else-if="item.EDCSS==='select'" v-model="perRow[item.FLDNO]" :disabled="item.FLDNO=='SUPTY' "  style="width:100%">
                                        <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                    </el-select> 
                                    <el-cascader v-else-if=" item.FLDNO==='AREA'"  style="width:100%" placeholder="可输入关键字查找"
                                        v-model="perRow[item.FLDNO]"  
                                        clearable
                                        filterable
                                        :options="areaArr">
                                    </el-cascader>
                                    <el-input  type="text" v-else :disabled="item.DISABLED==='Y'?true:false ||item.FLDNO=='PHONENO'"  v-model="perRow[item.FLDNO]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                    </div>
                    <div v-if="gpitem.gpno=='304'">   
                        <el-table  :data="perData" 
                            class="custom-table-border"
                            border                            
                            size="small"
                            ref="pertab"
                            :height="200" 
                            highlight-current-row > 
                            <span v-for="(item ) in perCol" :key="item.key" >
                                <el-table-column  v-if="item.thide==='N'&&item.key!=='STFG'"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"  
                                    :fixed="item.key==='EMPNM'"                                
                                    sortable
                                    :min-width="item.width">
                                </el-table-column> 
                                <el-table-column  v-if="item.key==='STFG'"
                                    :prop="item.key"
                                    :label="item.title"
                                    align="center"                                  
                                    width="70">
                                    <template slot-scope="scope" >
                                        <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row.STFG" >&nbsp;</el-checkbox>
                                    </template>
                                </el-table-column> 
                            </span> 
                            <el-table-column
                                fixed="right"
                                label="操作"
                                align="center"
                                width="150">
                                <template slot-scope="scope">
                                    <el-button size="small"   type="text" icon="el-icon-edit" @click="perEdit(scope.row,scope.$index)">编辑</el-button>
                                    <el-button size="small"  type="text" icon="el-icon-close" @click="perDel(scope.row,scope.$index)">删除</el-button>   
                                </template>
                            </el-table-column>                        
                        </el-table>
                    </div>
                    <div v-if="gpitem.gpno=='400070'"> 
                        <div style="display:flex;margin-top:5px;" >
                            <Upload
                                name="upfile"
                                :data="uploadData"
                                :show-upload-list="false"
                                :before-upload="beforeImgFile"
                                :on-success="successImgFile"
                                :on-progress="handleProgress"
                                :with-credentials="true"                            
                                :format="['jpg','jpeg','png','gif','tiff' ,'pdf']"
                                :max-size="10240"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                type="drag"       
                                :action="uploadUrl"
                                style="display: inline-block;width:200px; ">                           
                                <div style="padding: 1px 0;width:200px;height:183px;" @click="upClick('MER')">
                                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                </div>                                                       
                            </Upload> 
                            <div style="display:flex;margin-left:30px;height:193px;flex-wrap:wrap"  >
                                <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='MER')" :key="index">  
                                    <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                    </div>
                                    <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                                    <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <span style="font-weight:600;font-size:12px;color:red"> 文件名：</span>{{item.FILENM}}
                                    </div>
                                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                                        <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                                        <el-link v-else :underline="false" style="margin-right:5px;" @click="loadFile(item.FILEPATH,item.FILENM)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="gpitem.gpno=='400071'">
                        <div style="display:flex;margin-top:5px" >
                            <Upload
                                name="upfile"
                                :data="uploadData"
                                :show-upload-list="false"
                                :before-upload="beforeImgFile"
                                :on-success="successImgFile"
                                :on-progress="handleProgress"
                                :with-credentials="true"                            
                                :format="['jpg','jpeg','png','gif','tiff','pdf' ]"
                                :max-size="10240"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                type="drag"       
                                :action="uploadUrl"
                                style="display: inline-block;width:200px; ">                           
                                <div style="padding: 1px 0;width:200px;height:180px;"  @click="upClick('CERT')">
                                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                </div>                                                       
                            </Upload> 
                            <div style="display:flex;margin-left:30px;height:193px;flex-wrap:wrap"  >
                                <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='CERT')" :key="index">  
                                    <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                    </div>
                                    <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                                    <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <span style="font-weight:600;font-size:12px;color:red"> 文件名：</span>{{item.FILENM}}
                                    </div>
                                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                                        <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                                        <el-link v-else :underline="false" style="margin-right:5px;" @click="loadFile(item.FILEPATH,item.FILENM)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                                    </div>
                                </span>
                            </div>    
                        </div> 
                    </div>
                    </span>
                </div>         
                <div class="bottomdiv">
                    <div style="width:116px;font-size:18px;float:right;margin-right:160px ;font-weight:600 ">
                        <el-button   class="paybtn" @click="saveRec"  ><i class="iconfont icon-tijiao" style="margin-right:5px;"></i>提交修改</el-button>
                    </div>
                </div>  
            </div>  
        </div>        
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div  style="line-height:30px;" >{{prompt}} </div>
            <span slot="footer"  :style="{'height':'40px' }">
                <el-button size="small" type="primary" @click="promptWin=false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
 
        <!-- 联系人资料框 -->
        <el-dialog  v-dialogDrag :visible.sync="perWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{perFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div>
            <Form :model="contRow" :label-width="120"  label-position="right" inline :rules="perValidate" >  
                <span v-for="(item,index) in perCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="contRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="contRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="contRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <span slot="footer"  >
                <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="perWin=false" style="margin-right:25px;">取消</el-button>
                <el-button  type="primary" size="small" icon="iconfont icon-baocun"  @click="perSure" style="margin-right:10px;">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getDate} from '../../api/Select'
import { getTabColOrData,getBaseData } from '../../api/user'
export default {
        name: 'corp_info', 
        data () {
            return {
                v_css:'true',
                LANG:'CN',
                listurl:'',
                areaArr: [],
                comboArr:[],
                formArr:[],
                Accept: "png,jpg,jpeg,gif,tiff,pdf", //上传文件格式限制
                sendAuthCode:true,/*布尔值，通过v-show控制显示 获取按钮 还是 倒计时  */
                auth_time: 0, 
                perCol:[],
                userno:'',
                perRow:{},
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                delImg:[],    
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_formurl:'xuper_auth/getFormGroup', 
                uploadData:{}, //上传数据
                promptWin:false,
                prompt:'',
                videoFlag:false,
                videoUploadPercent:0,
   
                currentIndex:'0',
                form:{
                    userno:'',//请输入手机号
                    code:'',//获取校验码                   
                    pwd:'',
                    read:'N',
                    nation:'', //区号
                    usernm:'',
                    corpnm:'', //企业名
                    field:'', //行业
                    emplvl:'', //规模人数
                },
                perData:[],
                timeArr:[],
                contRow:{},
                perFlag:'create',
                perWin:false,
                rowIndex:'',
                stfgBool:true,
                v_action:'',
                notNull:[],
                imgData:[],
  
                uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
        
                fileName:'',
                perValidate:{'EMPNM':[{ required: true, message: '请输入员工姓名', trigger: 'blur' }],'TELNO':[{ required: true, message: '请输入手机号码', trigger: 'blur' }]},
            }
        },
        created () {
            //this.perRow['SUPTY'] ='397185'  //注册供应商
            //this.perRow['CRCY'] ='4238'
            
        },
        computed: {
 
            tabHeight: function() {
                return (window.innerHeight - 160) + 'px';
            }, 
        },
        mounted() {
            getBaseData('xuper_auth/getTableRecMany','','','','','V_GPLINE','').then(res=>{
                this.timeArr =res.result
            })
            this.form.nation ='0086'
            this.comSelect()
            //国家地区
            getBaseData('xuper_auth/getCascadeData','parentno','308' ,'','','v_sys_base','').then(res=>{
                this.areaArr =res.result
            })
            //表单资料分组 
            getTabColOrData(this.v_formurl,'','','v_sys_form_fld','idseq','100','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
                this.formArr = res.result             
            })
            //初始化数据
            this.initData()
            getTabColOrData('xuper_auth/getBaseData','','','v_sys_form_fld','idseq','100','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    this.perCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            //动态生成表单验证规则
            getTabColOrData('xuper_auth/getBaseData','','','v_sys_form_fld','idseq','100','LSTSEQ','1','NOTNULL','Y').then((res) => {
 
                this.notNull = res.result
 
            })
            
        },
        methods: {
            upClick(val){
                this.v_action= val  
            },
            handleTime(active,index){
                this.currentIndex=index
                // ref 用在v-for上时，得到的是一个数组，用在普通元素上，直接是 dom名
                this.$nextTick(()=>{
                    this.$refs[active['GPNO']][0].scrollIntoView({behavior:"smooth",block:"start"}) 
 
                })       
                //this.$refs[`#id${index}`].scrollIntoView({behavior:"smooth",block:"center"})    
            } ,
            initData(){
                let vm =this
                this.$axios({
                    method:'post', 
                    url:'xuper_auth/getBaseData',
                    data:{p_key:'corpid',p_value:this.v_corpid, p_table:'v_bs_sup',p_cond:' and (idNO=\''+vm.v_username+'\' or phoneno=\''+vm.v_username+'\')' },
                }).then(res =>{
                    if (res.code==='200') {
                        if (res.result.length>0 ){
                            this.perRow =res.result[0]
                            if (this.perRow['AREA']){
                                try{
                                    let row_ =this.perRow['AREA'].split(',')
                                    Object.assign(this.perRow,{AREA:row_})
                                }catch(err){
                                    //    
                                }
                            }

                            //联系人
                            this.$axios({
                                method:'post', 
                                url:'xuper_auth/getBaseData',
                                data:{p_table:'v_bs_supemp',p_key:'idseq',p_value: this.perRow['IDSEQ']},
                            }).then(res =>{
                                this.perData =res.result
                                this.$nextTick(() => { //有固定列时 查询后重新布局
                                    this.$refs.pertab.doLayout();
                                })
                            })
                        }
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }
                })
            },
            perSure(){
                if (!this.contRow['EMPNM']){
                    this.promptWin=true
                    this.prompt='姓名不能为空'
                }else if (!this.contRow['TELNO']){
                    this.promptWin=true
                    this.prompt='手机号码不能为空'
                }else{
                    this.perWin =false
                    if (this.perFlag==='edit' ){ //编辑时要替换数组记录
                        this.perData.splice(this.rowIndex,1,this.contRow)
                    }else{
                        this.perData.push(this.contRow)
                    }
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.pertab.doLayout();
                    })
                }
            },
            //保存记录
            saveRec(){
                var area_=''
                var vm =this 
                if (typeof(this.perRow['AREA'])!=='undefined' && this.perRow['AREA']!==''){
                    area_ =this.perRow['AREA'].join(',') 
                } 
                this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                    if (!this.perRow[item.FLDNO] ){
                        this.stfgBool =false 
                        this.promptWin =true
                        this.prompt=item.FLDNM+'不能为空'
                        return true
                    }else{
                        this.stfgBool =true  
                    }
                })
                //发起保存请求   
                if (this.stfgBool) {   
                    var telchk=/^1[3456789]\d{9}$/
                    if (!telchk.test(this.perRow['PHONENO'])) {
                        this.prompt ='绑定手机号码格式错误, 请重新输入'  
                        this.promptWin=true          
                    } else{
 
                        let obj_ ={}      
                        Object.assign(obj_,vm.perRow,{'AREA': area_, 'CORPID':this.v_corpid,ISREG:'Y'}) 
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(obj_), p_table:'bs_sup',frmid:'100'},
                        }).then(res=>{    
                            let v_idseq = res.idseq 
                            if(res.result ==='OK')  {  
                                //联络人保存：批量保存  res.idseq
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave',
                                    data: {p_json:JSON.stringify(this.perData), p_table:'BS_supEMP',p_idseq:v_idseq,p_action:'S' },
                                }).then(res=>{
                                    if (res.code!=='200'){
                                        this.promptWin=true
                                        this.prompt=res.result
                                    }else{
                                        this.promptWin =true
                                        this.prompt='已成功修改'      
                                    }
                                })
                                 //3、图片保存
                                for(var k=0;k<this.imgData.length;k++){
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:v_idseq},
                                    })
                                } 
                                //图片删除处理
                                for(let k=0;k<this.delImg.length;k++){
                                    let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                                    }).then(res=>{          
                                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                            this.$axios({
                                                method: 'post',
                                                url: '/xuper_oss/ftpDelete',
                                                data: {p_path:'/volume1'+v_path},
                                            }).then(res=>{ 
                                                console.log(res.result)
                                            })
                                        }
                                    })  
                                } 
    
                            }else{
                                this.$alert(res.result, '提示', {
                                    confirmButtonText: '确定',
                                    showClose:false,
                                    type:'info'
                                })
                            }        
                        }) 
                        
                    }
                }
            },
            //图片预览
            imgPreview(path){
                if (path &&path.indexOf('.pdf')>-1){
                    let routeUrl = this.$router.resolve({
                        path: '/fullPreview',
                        query: {fileUrl: path},
                    })
                    window.open(routeUrl.href, '_blank');
                } 
            },
            //图片删除，操作数组
            imgDel(item,index){
                this.$confirm('你确定要删除此文件吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
              
                    this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH']})           
                    this.imgData.splice(index, 1);            
                }).catch(()=>{})
            },
            //上传显示进度
            handleProgress(event,file,fileList){
                this.videoFlag = true
                this.videoUploadPercent = Math.floor(event.percent)
            },
            //文件格式验证错误时的钩子
            handleFormatError (file) {
                this.promptWin =true
                this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择图片或PDF文件格式'
            },
            //文件超出指定文件大小限制的钩子
            handleMaxSize (file) {
                this.promptWin =true
                this.prompt=file.name + ' 文件太大, 不能超出10M' 
            },
            // 文件上传成功时的钩子
            successImgFile(res,file){
                this.videoUploadPercent=0 
                this.videoFlag = false
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:this.v_action,PATH:'/web/web_images/material/'+res.result,REFLSTSEQ:this.dtlCol['LSTSEQ']})                   
                
            },
    
            //上传文件之前的钩子  
            beforeImgFile (res, file) {                              
                this.fileName= this.v_username+getDate('year')   
                this.uploadData = {
                    code: this.fileName ,
                    p_type:'IMG',
                    p_path:'/web/web_images/material/',
                    p_user:this.v_username
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise;
            },
 
            perEdit(row ,index){
                this.contRow=JSON.parse(JSON.stringify(row))
                this.perWin=true
                this.perFlag='edit'
                this.rowIndex=index
            } ,
            perDel(row,index){
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.perData.splice(index,1)
                }).catch(()=>{})
            },
            //动态赋值下拉框
            comSelect(){  
                this.$axios({
                    method:'post', 
                    url: 'xuper_auth/getBaseData' ,
                    data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'100',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
                }).then(res =>{
                    if (res.result.length>0){
                        for(let k=0;k<res.result.length;k++){
                            getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                                this.comboArr[res.result[k].FLDNO] =res2.result
                            })
                        }
                    }
                })  
            },
            perAdd(){
                this.contRow={'STFG':'N'}
                this.perFlag='create'
                this.perWin=true
            },
         
        }
    }
</script>

<style scoped lang="less">
    .bottomdiv{
        background:#e8eaec;
        height:40px;
        line-height:40px;
        margin-top:1px ;
    }
    .bottombtn{
        height:40px;
        background:#67C23A;
        width:175px;
        color:white;
        font-size:14px;
    }
    .paybtn:hover{
        background:#E6A23C;
    }
    .paybtn{
        height:40px;
        background:#F56C6C;
        width:120px;
        color:white;
        font-size:15px;
    }
    .item-width  {
        width: 31%;
    }
    .item-width2  {
        width: 98%;
        color:#409EFF;
    }
    .main_back{
        height: 90vh;
        background:white;
    }
 
</style>
<style>
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 25px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
